import { getElementOffset, wrapAll } from './Utils';
import debounce                      from 'lodash-es/debounce';

export default class ShowMore
{
    constructor ( toggler )
    {

        this.toggler = toggler;


        this.elementsContainerSelector   = this.toggler.dataset.elementsContainerSelector ?? '';
        this.elementsContainer           = document.querySelector( this.elementsContainerSelector );
        this.moreContentElementsSelector = this.toggler.dataset.moreContentElementsSelector ?? '';
        this.moreContentElements         = this.elementsContainer.querySelectorAll( this.moreContentElementsSelector );
        this.howManyToShowInitially      = parseInt( this.toggler.dataset.howManyToShowInitially ?? 0 );


        if ( !this.elementsContainer || !this.moreContentElements )
        {
            console.error( '[ShowMore] Not enough information.' );
        }

        this.partnerId = 'show-more-partner_' + Math.floor( Math.random() * 9999999 );

        // console.log( 'begin',
        //     this.elementsContainerSelector,
        //     this.elementsContainer,
        //     this.moreContentElementsSelector,
        //     this.moreContentElements,
        //     this.howManyToShowInitially,
        // )


        this.isProfileBadges = this.toggler?.dataset?.isProfileBadges ?? false;

        if ( this.isProfileBadges )
        {

            this.howManyInitialRows = parseInt( this.toggler?.dataset?.maxInitalRows ?? 1 );
            this.setupProfileBadges();

        } else
        {

            this.setup();

        }


    }


    bindEvents ()
    {
        this.toggler.addEventListener( 'click', this.handleToggle.bind( this ) );

        if ( this.isProfileBadges )
        {

            const debouncedResize = debounce( () =>
            {
                this.balanceBadges();
            }, 300 );

            window.addEventListener( 'resize', debouncedResize.bind( this ) );
        }
    }

    handleToggle ()
    {
        if ( this.open )
        {
            this.hideMoreContent();
        } else
        {
            this.showMoreContent();
        }
    }

    showMoreContent ()
    {
        this.toggler.setAttribute( 'aria-expanded', true );
        this.moreWrapper.classList.add( 'open' );
        this.open              = true;
        this.toggler.innerText = 'Voir moins';
    }

    hideMoreContent ()
    {
        this.toggler.setAttribute( 'aria-expanded', false );
        this.moreWrapper.classList.remove( 'open' );
        this.open              = false;
        this.toggler.innerText = 'Voir plus';
    }

    setup ()
    {
        this.open = false;


        this.toggler.setAttribute( 'aria-expanded', false );

        if ( this.moreContentElements )
        {

            const arrAllElements = Array.from( this.moreContentElements );

            const firstGroup = arrAllElements.slice( 0, this.howManyToShowInitially );
            const rest       = arrAllElements.slice( this.howManyToShowInitially );


            if ( rest && rest.length > 0 )
            {
                // console.log( '[ShowMore]', firstGroup, rest, arrAllElements );

                const wrapper = this.createWrapper();

                rest.forEach( ( bagdeGroup ) =>
                {
                    this.moreWrapper.appendChild( bagdeGroup );
                } )


                this.bindEvents();
            } else
            {
                this.toggler.style.display = "none";
            }
        }


    }

    createWrapper ()
    {
        this.moreWrapper = document.createElement( 'div' );
        this.moreWrapper.classList.add( 'more-content' );
        this.moreWrapper.setAttribute( 'id', this.partnerId );

        this.moreWrapper = this.elementsContainer.appendChild( this.moreWrapper );
        this.toggler.setAttribute( 'aria-controls', this.partnerId );

        return this.moreWrapper;
    }

    setupProfileBadges ()
    {

        this.open = false;

        this.partnerId = 'show-more-partner_' + Math.floor( Math.random() * 9999999 );

        if ( typeof this.moreWrapper === 'undefined' )
        {
            this.createWrapper();
        }
        this.balanceBadges();

        this.bindEvents();
    }

    balanceBadges ()
    {

        this.toggler.setAttribute( 'aria-expanded', false );
        //reset
        const moreBadges = this.moreWrapper.querySelectorAll( this.moreContentElementsSelector );


        if ( moreBadges && moreBadges.length > 0 )
        {
            Array.from( moreBadges ).forEach( ( moreBadge ) =>
            {
                // console.log( 'appending', moreBadge )
                this.elementsContainer.appendChild( moreBadge );
            } );

            this.moreWrapper.remove();
            this.createWrapper();
        }

        // reset the var
        this.moreContentElements = this.elementsContainer.querySelectorAll( this.moreContentElementsSelector );


        let hasSomethingToHide = false;

        // measure who ends up on the nth line past the max we want
        let highestY = 0;
        let row      = 0;

        Array.from( this.moreContentElements ).forEach( ( badgeGroup ) =>
        {
            const position = getElementOffset( badgeGroup );

            // the first time, it WILL be bigger, but not after that...
            // ...until we change rows
            if ( position.top > highestY )
            {
                highestY = position.top;
                row++;
            }

            // console.log( position.top, highestY, badgeGroup, row );

            if ( row > this.howManyInitialRows )
            {
                this.moreWrapper.appendChild( badgeGroup );
                hasSomethingToHide = true;
            }


        } );

        if ( hasSomethingToHide )
        {


        } else
        {

        }

        this.hideMoreContent();

    }

}
